import { Box, SimpleGrid } from '@chakra-ui/react';
import { IRecipe } from '@/_types';
import SeoPageTitle from '@/_components/SeoPageTitle';
import { useTranslations } from 'next-intl';
import { SegmentedControl } from '@/components/ui/segmented-control';
import { BRAND_NAMES, FEATURED_BRANDS } from '@/_utils/Constants';
import RecipeEmptyState from '../empty-state';
import RecipeCard from '../../Card';
import UniversalHeader from '@/_components/Header';

export default function Mobile({
  data,
  isLoading,
  activeBrandId,
  setActiveBrandId,
}: {
  data?: IRecipe[];
  isLoading: boolean;
  activeBrandId: string;
  setActiveBrandId: (id: string) => void;
}) {
  const t = useTranslations();
  return (
    <Box bg={'background'} minH={'100vh'}>
      <UniversalHeader backLink='/profile' title={t('recipes')} />
      <SeoPageTitle>{t('recipes')}</SeoPageTitle>
      <Box
        px={4}
        mt={2}
        mb={4}
        maxW='100vw'
        overflowX='auto'
        overflowY='visible'
        h='fit-content'
      >
        <SegmentedControl
          size='sm'
          height='36px'
          variant='chip'
          fontWeight={600}
          value={activeBrandId}
          onValueChange={(e) => {
            if (e.value) setActiveBrandId(e.value);
          }}
          items={Object.entries(BRAND_NAMES)
            // Hide Yoko Pizza
            .filter(([id]) => id !== FEATURED_BRANDS.yokopizza)
            ?.map(([id, name]) => ({
            label: name,
            value: id,
          }))}
        />
      </Box>
      <Box mt={2} px={4} pb={10}>
        {isLoading ? null : data?.length ? (
          <SimpleGrid columns={2} gap={2}>
            {data.map((el) => (
              <RecipeCard key={el.id} data={el} shipperId={activeBrandId} />
            ))}
          </SimpleGrid>
        ) : (
          <RecipeEmptyState />
        )}
      </Box>
    </Box>
  );
}
